import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  getPasswordHelper,
  isPasswordSecure,
  PASSWORD_VALIDATION_ERROR,
} from "../../../common/utils/passwordSecurity";

const PasswordForm = ({ user, updateUserForm }) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [passwordIsFocused, setPasswordIsFocused] = React.useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        id: user ? user.id : "",
        password: "",
        passwordConfirmation: "",
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
          updateUserForm(values);
          setIsEditing(false);
          setPasswordIsFocused(false);
        }, 500);
      }}
      validationSchema={Yup.object().shape({
        id: Yup.string(),
        password: Yup.string()
          .required("Champ Requis")
          .test(
            "password-security-requirements",
            PASSWORD_VALIDATION_ERROR,
            (value) => !value || isPasswordSecure(value),
          ),
        passwordConfirmation: Yup.string()
          .required("Champ Requis")
          .oneOf(
            [Yup.ref("password"), null],
            "Les mots de passes doivent être identiques",
          ),
      })}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;

        const passwordHelper = getPasswordHelper(values.password);

        return (
          <form onSubmit={handleSubmit}>
            <h4 className="mb-2">
              <i className="feather icon-lock" style={{ marginRight: 5 }} />
              Sécurité
            </h4>
            <div className="row">
              <div className="col-12">
                <div className="form-group has-danger">
                  <div>
                    <label htmlFor="password">Mot de passe</label>
                    {isEditing ? (
                      <>
                        <input
                          type="password"
                          id="password"
                          placeholder="Mot de passe"
                          className="form-control"
                          onChange={handleChange}
                          onBlur={(event) => {
                            handleBlur(event);
                            setPasswordIsFocused(false);
                          }}
                          onFocus={() => setPasswordIsFocused(true)}
                          value={values.password}
                        />
                        {passwordIsFocused && (
                          <div className={passwordHelper.className}>
                            {passwordHelper.message}
                          </div>
                        )}
                        {errors.password &&
                          touched.password &&
                          (!passwordIsFocused ||
                            errors.password !== PASSWORD_VALIDATION_ERROR) && (
                            <div className="mt-1 danger">
                              {errors.password}
                            </div>
                          )}
                      </>
                    ) : (
                      <p className="font-weight-bold">**********</p>
                    )}
                  </div>
                </div>
              </div>
              {isEditing && (
                <div className="col-12">
                  <div className="form-group has-danger">
                    <div>
                      <label htmlFor="passwordConfirmation">
                        Confirmer le mot de passe
                      </label>
                      <input
                        type="password"
                        id="passwordConfirmation"
                        placeholder="Confirmer le mot de passe"
                        className="form-control"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.passwordConfirmation}
                      />
                      {errors.passwordConfirmation &&
                        touched.passwordConfirmation && (
                          <div className="mt-1 danger">
                            {errors.passwordConfirmation}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              )}

              <div className="col-12 d-flex justify-content-end">
                {isEditing ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary mr-1"
                      onClick={() => {
                        setIsEditing(false);
                        setPasswordIsFocused(false);
                      }}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary ">
                      Enregistrer
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setIsEditing(true)}
                  >
                    Modifier
                    <i className="feather icon-edit-1 ml-1" />
                  </button>
                )}
              </div>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default PasswordForm;
